"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundingRequestComponentTypeSchema = exports.FundingRequestComponentType = void 0;
const v4_1 = require("zod/v4");
// @deprecated: use FundingRequestComponentTypeNew instead
var FundingRequestComponentType;
(function (FundingRequestComponentType) {
    FundingRequestComponentType["CollectionsPaydown"] = "collectionsPaydown";
    FundingRequestComponentType["CollectionsRecycle"] = "collectionsRecycle";
    FundingRequestComponentType["CurePaydown"] = "curePaydown";
    FundingRequestComponentType["DrawRequest"] = "drawRequest";
})(FundingRequestComponentType || (exports.FundingRequestComponentType = FundingRequestComponentType = {}));
exports.FundingRequestComponentTypeSchema = v4_1.z.enum([
    'collectionsPaydown',
    'collectionsRecycle',
    'curePaydown',
    'drawRequest',
]);
//# sourceMappingURL=SharedFundingRequest.js.map